module.exports = __webpack_public_path__ + "static/media/iStock-695360068.9b23c830.jpg";